import React from 'react';
import PropTypes from 'prop-types';
import MaterialNumberField from 'shared/components/connectedTextField/c/materialNumberField/MaterialNumberField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RemoveIcon from '@material-ui/icons/Clear';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';

const inputStyle = { width: '100%', marginLeft: 24 };
const textStyle = { fontSize: 15, color: textColorGray };
const noAllocationSelected = 0;

class CostObjAllocationUnit extends React.Component {
  constructor(props){
    super(props);
    const { 
      id,
      unitCount,
      unitCountAvailable,
      originalUnitCountAvailable
    } = props.allocationUnit;
    const originalCostObjAllocationUnit = props.originalCostObjAllocationUnits.find( allocUnit => allocUnit.id === id);
    this.state = {
      pristineTextField: false,
      allocationUnitChanged: false,
      allocationUnit: {
        id,
        currentAllocationUnitId: id,
        unitCount,
        unitCountAvailable,
        originalUnitCountAvailable,
        totalCountAvailable: originalCostObjAllocationUnit ? originalCostObjAllocationUnit.unitCount + originalCostObjAllocationUnit.unitCountAvailable : unitCount + unitCountAvailable,
        currentCountAvailable: unitCount
      }
    };
  }

  handleInputChange = (ev, value) => {
    const numberValue = value === '' ? '' : parseInt(value);
    const target = ev.target;
    const { totalCountAvailable } = this.state.allocationUnit;
    const remainingAllocationUnits = totalCountAvailable - numberValue;
    this.setState(oldState => ({
      allocationUnit: { 
        ...oldState.allocationUnit, 
        [target.name]: numberValue,
        unitCountAvailable: remainingAllocationUnits
      }
    }), () => {
      this.props.onAllocationUnitChange(this.state.allocationUnit);
    });
  }
  
  handleSelectChange = (ev, index, value) => {
    const { originalCostObjAllocationUnits, emptyAllocationUnit } = this.props;
    if ( value === noAllocationSelected ) {
      this.setState({
        allocationUnit: {
          ...emptyAllocationUnit
        }
      }, () => {
        this.props.onAllocationUnitChange(this.state.allocationUnit);
      });
    } else {
      const selectedAllocationUnit = this.props.allocationUnits.find( allocationUnit => allocationUnit.id === value );
      const originalCostoObjAllocationUnit = originalCostObjAllocationUnits.find( allocUnit => allocUnit.id === selectedAllocationUnit.id );
      const { currentCountAvailable } = this.state.allocationUnit;
      const extraCount = this.state.allocationUnitChanged ? currentCountAvailable : 0;
      const totalCountAvailable = originalCostoObjAllocationUnit ? 
        originalCostoObjAllocationUnit.unitCount + originalCostoObjAllocationUnit.unitCountAvailable :  
        selectedAllocationUnit.unitCountAvailable + extraCount;
      this.setState(oldState => ({...oldState, pristineTextField: true }));
      this.setState(oldState => ({
        allocationUnit: { 
          ...oldState.allocationUnit, 
          id: value, 
          unitCount: '',
          unitCountAvailable: selectedAllocationUnit ? selectedAllocationUnit.unitCountAvailable : 0,
          originalUnitCountAvailable: selectedAllocationUnit ? selectedAllocationUnit.unitCountAvailable : 0,
          totalCountAvailable: totalCountAvailable ? totalCountAvailable : selectedAllocationUnit.unitCountAvailable
        }
      }), () => {
        this.props.onAllocationUnitChange(this.state.allocationUnit);
      });
    
    }
    this.props.onSelectAllocationUnitChange(this.state.allocationUnit.id, value);
  }
  
  handleRemoveAllocationUnit = () => {
    this.props.onRemoveAllocationUnit();
    this.props.onSelectAllocationUnitChange(this.state.allocationUnit.id, 0);
  }

  handleRequiredAmount = () => this.setState(oldState => ({ ...oldState, pristineTextField: false }));

  render() {
    const { allocationUnits, fetchingAllocationUnits, showRemoveIcon } = this.props;
    const {
      id,
      unitCount,
      unitCountAvailable,
      totalCountAvailable
    } = this.state.allocationUnit;
    return (
      <div className="cost-obj-allocation-unit-container">
        <SelectField
          name={ 'allocationUnitKey' }
          hintText="Select Allocation Units"
          className="cost-obj-allocation-unit-container__inputs-column"
          style={ { marginTop: 24 } }
          fullWidth={ true }
          maxHeight={ 400 }
          iconStyle={ { fill: disabledButtonTextGray } }
          hintStyle={ textStyle }
          labelStyle={ textStyle }
          underlineStyle={ { borderColor: disabledButtonTextGray } }
          value={ id }
          onChange={ this.handleSelectChange }
          disabled= { fetchingAllocationUnits }
        >
          <MenuItem 
            value={ 0 }
            primaryText="Select Allocation Units"
            style={ { color: '#bcbcbc' } }
          />
          {
            allocationUnits.map( allocationUnit => (
              <MenuItem 
                key={ allocationUnit.id }
                value={ allocationUnit.id }
                primaryText={ allocationUnit.name }
                disabled={ allocationUnit.disabled || allocationUnit.unitCountAvailable === 0 }
              />
            ))
          }
        </SelectField>
        <div className="cost-obj-allocation-unit-container__inputs-column">
          <div className="cost-obj-allocation-unit-container__inputs-column">
            <MaterialNumberField
              name={ 'unitCount' }
              label="Amount"
              value= { unitCount }
              onChange={ this.handleInputChange }
              style={ inputStyle }
              fullWidth={ true }
              errorText={
                totalCountAvailable && (totalCountAvailable - unitCount) < 0  ? `Amount cannot exceed available` : '' 
              }
              disabled={ !id }
              required={ id !== 0 }
              pristineForm= { this.state.pristineTextField }
              onBlur={ this.handleRequiredAmount }
            />
          </div>
          {
            unitCountAvailable !== (undefined || '') && id !== 0 &&
            <div 
              className="cost-obj-allocation-unit-container__label" 
              style={ totalCountAvailable - unitCount < 0 ? { color: 'red' } : { color: 'inherit' } }
            >
              / { totalCountAvailable - unitCount > 0 ? totalCountAvailable - unitCount : 0 } Available
            </div>
          }
        </div>
        {
          showRemoveIcon &&
          <RemoveIcon className="cost-obj-allocation-unit-container__label" style={ { cursor: 'pointer' } } onClick={ this.handleRemoveAllocationUnit }/>
        }
      </div>
    );
  }
}

CostObjAllocationUnit.propTypes = {
  allocationUnits: PropTypes.array.isRequired,
  onAllocationUnitChange: PropTypes.func.isRequired,
  onSelectAllocationUnitChange: PropTypes.func.isRequired,
  originalCostObjAllocationUnits: PropTypes.array,
  fetchingAllocationUnits: PropTypes.bool.isRequired,
  onRemoveAllocationUnit: PropTypes.func.isRequired,
  showRemoveIcon: PropTypes.bool.isRequired,
  showAddIcon: PropTypes.bool.isRequired,
  allocationUnit: PropTypes.object.isRequired,
  emptyAllocationUnit: PropTypes.object
};

export default CostObjAllocationUnit;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/c/CostObjAllocationUnit.js